import React, { PureComponent } from 'react'
import Modal from '../../components/modal/modal'
import Button from '../../components/button/button'
import { deleteClazzCourse } from '../../api/clazz-course'
import message from '../../components/message/message'

class CourceDeleteModal extends PureComponent {
  constructor(props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
    console.log(this.props.deleteId)
  }
  async handleSubmit() {
    const params = { clazz_id:this.props.clazz_id,course_id:this.props.course_id }
    const res = await deleteClazzCourse(params)
    if (res) {
      this.props.onClose()
      message.show(res)
    }
  }
  render() {
    return (
      <Modal onClose={this.props.onClose} title='删除课程'>
          <p
            style={{
              width: '100%',
              textAlign: 'center',
              color: '#5391E4',
              fontSize: '16px',
              fontWeight: 'bold',
              marginTop: '40px',
              marginBottom: '60px'
            }}
          >
            是否删除当前课程？
      </p>
          <div style={{ textAlign: 'center' }}>
            <Button
              style={{ marginRight: '20px' }}
              theme={'submit'}
              label='确定'
              onClick={this.handleSubmit}
            />
            <Button
              label='取消'
              onClick={this.props.onClose}
            />
          </div>
      </Modal>
    )
  }
}

// const mapStateToProps = () => {
//   return
// }

// const mapDispatchToProps = dispatch => ({
//   setMyProjects: projects => dispatch(setMyProjects(projects))
// })

// export default connect(mapStateToProps, mapDispatchToProps)(ProjectsDeleteModal)
export default CourceDeleteModal
